// extracted by mini-css-extract-plugin
module.exports = {"noCoversations":"HomeMessages_noCoversations__2jh-y","notification":"HomeMessages_notification__23JMh"};